export const bolepidemiologicos2025IAAS = [
  {
    "etiqueta_elemento": "Boletin 1er Trimestre 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/IAAS/Boletín IAAS Hidalgo 1er trimestre 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin 2o Trimestre 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/IAAS/Boletín IAAS Hidalgo 2o trimestre 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin 3er Trimestre 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/IAAS/Boletín IAAS Hidalgo 3er trimestre 2025.pdf",
  },
  {
    "etiqueta_elemento": "Boletin 4o Trimestre 2025",
    "url_elemento":"../../../contenido/epidemiologia/2025/IAAS/Boletín IAAS Hidalgo 4to trimestre 2025.pdf",
  },
]